
<template>

<v-container grid-list-md>
      <v-layout row wrap>
            <v-dialog
                v-model="dialogFirstCall"
                
                persistent
                width="400"
                height="400px"
            >
           <v-card
                color="rgba(1, 34, 68, 0.8)"
                dark
            >
                <v-card-text>
                    Cargando...
                    <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
                </v-card>
            </v-dialog>
       </v-layout>
</v-container>
 
</template>

<script>
// @ is an alias to /src

import {mapGetters,mapMutations} from "vuex";

export default {
  name: 'loading',
  components: {

  },
    data () {
    return {
      
    }
    },
      computed: {
    ...mapGetters(["dialogFirstCall"]),
      },
    methods:{
       
    ...mapMutations(['setdialogFirst'])
 

    }
    ,created(){

    }
}
</script>